import { useEffect, useMemo, useState } from "react";
import { useTema } from "./ThemeProvider";
import { urlAsset } from "../utils/assets";
import { EVENTO_ASSETS_SISTEMA } from "../utils/configuracoesSistema";
import { lerEmpresaLoginSelecionada } from "./empresaLogin";

interface MarcasEmpresa {
  logoUrl: string;
  logoFechadaUrl: string;
  iconeUrl: string;
  marcaRecolhidaUrl: string;
}

async function rpcPublico<T>(nome: string, ...args: unknown[]): Promise<T | null> {
  try {
    const resposta = await fetch(`/api/rpc/${nome}`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
      cache: "no-store",
      body: JSON.stringify({ args }),
    });
    return resposta.ok ? ((await resposta.json()) as T) : null;
  } catch {
    return null;
  }
}

export function useMarcasEmpresa(): MarcasEmpresa {
  const { tema } = useTema();
  const [logoUrl, setLogoUrl] = useState("");
  const [logoFechadaUrl, setLogoFechadaUrl] = useState("");
  const [iconeUrl, setIconeUrl] = useState("");

  useEffect(() => {
    let ativo = true;

    async function carregarMarcas() {
      const codEmpresa = lerEmpresaLoginSelecionada();
      const [logo, logoFechada, icone] = await Promise.all([
        rpcPublico<string>("obterLogoEmpresaPorTema", tema, codEmpresa),
        rpcPublico<string>("obterLogoFechadaPorTema", tema, codEmpresa),
        rpcPublico<string>("obterIconeEmpresa", codEmpresa),
      ]);
      if (!ativo) return;
      setLogoUrl(logo ? urlAsset(String(logo)) : "");
      setLogoFechadaUrl(logoFechada ? urlAsset(String(logoFechada)) : "");
      setIconeUrl(icone ? urlAsset(String(icone)) : "");
    }

    const atualizar = () => void carregarMarcas();
    void carregarMarcas();
    window.addEventListener(EVENTO_ASSETS_SISTEMA, atualizar);
    return () => {
      ativo = false;
      window.removeEventListener(EVENTO_ASSETS_SISTEMA, atualizar);
    };
  }, [tema]);

  return useMemo(() => ({
    logoUrl,
    logoFechadaUrl,
    iconeUrl,
    marcaRecolhidaUrl: logoFechadaUrl || iconeUrl,
  }), [iconeUrl, logoFechadaUrl, logoUrl]);
}
